import { gql } from '@apollo/client';

export const getOrganization = gql`
  query getOrganization($id: ID!) {
    getOrganization(id: $id) {
      id
      type
      name
      hasActiveScimClient
      subscription {
        id
        seats
      }
    }
  }
`;

export const listOrganizations = gql`
  query listOrganizations($pagination: PaginationInput) {
    listOrganizations(pagination: $pagination) {
      id
      name
      archived
    }
  }
`;
